import api from "@/lib/api";

const EXT_TYPES = {
  pdf: "application/pdf", jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", webp: "image/webp",
  heic: "image/heic", heif: "image/heif", mp4: "video/mp4", mov: "video/quicktime", webm: "video/webm",
  doc: "application/msword", docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel", xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  txt: "text/plain", csv: "text/csv",
};

async function withRetry(fn, tries = 3) {
  for (let i = 0; ; i++) {
    try { return await fn(); } catch (e) { if (i >= tries - 1 || (e.response && e.response.status < 500)) throw e; }
  }
}

// Caricamento a pezzi da 4 MB: supera i limiti del proxy anche per video grandi
export async function uploadFile(file, onProgress) {
  const ext = (file.name.split(".").pop() || "").toLowerCase();
  const contentType = file.type || EXT_TYPES[ext] || "application/octet-stream";
  const { data } = await api.post("/uploads/init", { filename: file.name, content_type: contentType, size: file.size });
  const size = data.chunk_size;
  const total = Math.ceil(file.size / size);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("file", file.slice(i * size, (i + 1) * size), file.name);
    await withRetry(() => api.post(`/uploads/${data.upload_id}/chunk?index=${i}`, fd));
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return data.upload_id;
}

export function formatSize(bytes) {
  return bytes < 1048576 ? `${Math.max(1, Math.round(bytes / 1024))} KB` : `${(bytes / 1048576).toFixed(1)} MB`;
}

export async function openBlob(path, filename) {
  // La finestra si apre subito (gesto dell'utente) cos\u00ec iPhone non la blocca
  const win = filename ? null : window.open("", "_blank");
  try {
    const r = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    if (win) {
      win.location.href = url;
    } else {
      const a = document.createElement("a");
      a.href = url; a.download = filename || "file"; a.click();
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    win?.close();
    throw e;
  }
}
